import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/AdBanner.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/content/Header.module.css");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/content/Content.module.css");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/navbar/Navbar.tsx")